import { BuyerSellerDetails } from "../../../tc-models/tc-req-dto/tc-buyer-seller-details.req_dto";

type PartyField = keyof BuyerSellerDetails;

export interface ReturnTcPartyMismatch {
  field: PartyField;
  label: string;
  expected: string;
  actual: string;
}

const PARTY_FIELDS: Array<{ field: PartyField; label: string }> = [
  { field: "sellerTEId", label: "Seller TE-ID" },
  { field: "sellerName", label: "Seller Name" },
  { field: "sellerAddress1", label: "Seller Street Address" },
  { field: "sellerTown", label: "Seller Town" },
  { field: "sellerPostcode", label: "Seller Postcode" },
  { field: "sellerCountryOrArea", label: "Seller Country/Area" },
  { field: "sellerStateOrProvince", label: "Seller State/Province" },
  { field: "buyerTEId", label: "Buyer TE-ID" },
  { field: "buyerName", label: "Buyer Name" },
  { field: "buyerAddress1", label: "Buyer Street Address" },
  { field: "buyerTown", label: "Buyer Town" },
  { field: "buyerPostcode", label: "Buyer Postcode" },
  { field: "buyerCountryOrArea", label: "Buyer Country/Area" },
  { field: "buyerStateOrProvince", label: "Buyer State/Province" },
];

const normalize = (value: unknown) =>
  String(value ?? "")
    .trim()
    .replace(/\s+/g, " ")
    .toLocaleLowerCase();

const isBlankSourceValue = (value: unknown) =>
  ["", "na", "n/a", "not available", "not applicable", "null"].includes(
    normalize(value)
  );

export const findReturnTcPartyMismatches = (
  current: Partial<BuyerSellerDetails>,
  expectedFromSource: Partial<BuyerSellerDetails>
): ReturnTcPartyMismatch[] =>
  PARTY_FIELDS.flatMap(({ field, label }) => {
    const expected = expectedFromSource[field];
    if (isBlankSourceValue(expected)) return [];

    const actual = current[field];
    if (normalize(actual) === normalize(expected)) return [];

    return [
      {
        field,
        label,
        expected: String(expected ?? ""),
        actual: String(actual ?? ""),
      },
    ];
  });

export const returnTcPartyMismatchMessage = (
  mismatches: ReturnTcPartyMismatch[]
) =>
  `Return TC parties must match the incoming TC with roles reversed. Mismatched field(s): ${mismatches
    .map(({ label }) => label)
    .join(", ")}`;
